import React, { useState } from "react";
import styled from "styled-components";

const CustomRadio = ({ text, checked, onChange, name, value }) => {
    return (
        <RadioContainer>
            <HiddenRadio
                checked={checked}
                onChange={onChange}
                name={name}
                value={value}
            />
            <StyledRadio checked={checked}>
                {checked && (
                    <CheckIcon viewBox="0 0 24 24" fill="none">
                        <path d="M5 13l4 4L19 7" />
                    </CheckIcon>
                )}
            </StyledRadio>
            <InquireText>{text}</InquireText>
        </RadioContainer>
    );
};

const HiddenRadio = styled.input.attrs({ type: "radio" })`
    display: none;
`;

const StyledRadio = styled.div`
    width: 16px;
    height: 16px;
    background: ${(props) => (props.checked ? "#7386E8" : "#ccc")};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
`;

const CheckIcon = styled.svg`
    width: 14px;
    height: 14px;
    stroke: white;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
`;

const RadioContainer = styled.label`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    gap: 25px;
`;

const InquireText = styled.p`
    font-size: 16px;
    font-weight: 700;
    color: #000000;
`;

export default CustomRadio;
